// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"249":"c3790c1462d5876f","698":"cef7b38f42a23fd3"}[chunkId] + ".js";
};